export default __webpack_public_path__ + "01e0f6627d2cc13c4c2c0ed1287fd517.png";